import { default as QuantitySelector } from './quantity-selector'
export * from './quantity-selector'

export default QuantitySelector
